module.exports = __webpack_public_path__ + "121a9fe0e135271eaec86689148e3edf.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/privacy-certified-2.png
// module id = 516
// module chunks = 0